<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Solicitud {{ $platform.setting.number_symbol }}{{ data.id }}</h4>
				</div>
				<div class="list-group m-b-0">
					<button type="button" @click="openShow(data)" class="list-group-item">
						<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
						Ver
					</button>
					<button type="button" @click="openEdit(data)" class="list-group-item">
						<i class="ti-pencil-alt fa-fw"></i>
						Editar
					</button>
					<template v-if="user.hasRole('admin')">
						<button type="button" @click="destroy(data)" class="list-group-item" :disabled="data.request_status_id == 2 || data.request_status_id == 4" :class="{ 'disabled': data.request_status_id == 2 || data.request_status_id == 4 }">
							<i class="fa fa-trash" aria-hidden="true"></i>
							Eliminar
						</button>
					</template>

					<template v-if="canBecomeCustomer(data)">
						<button type="button" @click="addCustomer(data)" class="list-group-item">
							<i class="fa fa-plus fa-fw" aria-hidden="true"></i>
							Cliente
						</button>
					</template>

					<template v-if="data.customers">
						<template v-if="data.customers.length">
							<template v-for="customer in data.customers">
								<button type="button" @click="addBudget(data, customer)" class="list-group-item">
									<i class="fa fa-plus fa-fw" aria-hidden="true"></i>
									Presupuesto
								</button>
							</template>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'requests-actions-' + new Date().getTime(),
				},

				data: null
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				} else {
					this.data = null
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			canBecomeCustomer(request) {
				var can = false
				if(request.data) {
					if(request.data) {
						if(request.data.length) {
							var name = request.data.find(function(element) {
								return element.id == 'name'
							})
							if(name) {
								var length = null
								if(request.customers) {
									if(request.customers.length) {
										length = request.customers.length
									}
								}
								if(!length) {
									can = true
								}
							}
						}
					}
				}
				return can
			},
			openShow(data) {
				this.close()
				this.$emit('openShow', data)
			},
			openEdit(data) {
				this.close()
				this.$emit('openEdit', data)
			},
			addCustomer(data) {
				this.close()
				this.$emit('addCustomer', data)
			},
			addBudget(data, customer) {
				this.close()
				this.$emit('addBudget', data, customer)
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Actions.vue